import { memo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import { GenericShortListFilter } from '@hotjar/global-filters';
import { ACTION_FILTER_OPTIONS, ACTION_FILTERS } from '../../constants';
import type { ActionFilter } from '../../types';

type Props = {
  filters: ActionFilter[] | undefined;
  onFilterChange: (filters: ActionFilter[] | undefined) => void;
};

const StyledContainer = styled.div`
  display: flex;
  padding: ${tokens.spacer.x1} ${tokens.spacer.x2} ${tokens.spacer.x1};
  background-color: ${tokens.color.neutral_100};

  border-top: 1px solid ${tokens.color.ui_border};
  border-bottom: 1px solid ${tokens.color.ui_border};

  & > div {
    background-color: white;
  }
`;

export const getFilterLabel = (selectedFilters?: ActionFilter[]) => {
  if (selectedFilters?.length === ACTION_FILTER_OPTIONS.length) {
    return 'common:player.actions-list.action-type.all-actions';
  }

  if (selectedFilters?.length === 1) {
    return ACTION_FILTERS[selectedFilters[0]].label;
  }

  return 'common:player.actions-list.action-type.some-actions';
};

const InternalActionsFilter = ({ filters, onFilterChange }: Props): JSX.Element => {
  const { t } = useTranslation();
  const optionList = useRef(
    ACTION_FILTER_OPTIONS.map(({ value, label }) => ({ value, label: t(label, { count: 0 }) })),
  );

  return (
    <StyledContainer>
      <GenericShortListFilter
        filterName=""
        label2={t(getFilterLabel(filters), {
          count: filters && filters.length > 1 ? filters.length : 0,
        })}
        showDropdownCaret
        currentValue={filters}
        isInactive
        optionList={optionList.current}
        onApply={onFilterChange}
        selectAllLabel={t('common:player.actions-list.action-type.all-actions')}
      />
    </StyledContainer>
  );
};

export const ActionsFilter = memo(InternalActionsFilter);
